var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tbody",
    { staticClass: "contractor-edit" },
    [
      _vm._l(_vm.currentContractors, function (contractor) {
        return _c("tr", { key: contractor.id }, [
          _c(
            "td",
            { staticClass: "user-account-input" },
            [
              _c("InputField", {
                attrs: {
                  value: contractor.userAccount,
                  pattern: _vm.regex.email,
                  inputTip: _vm.errorEmail,
                  required: true,
                },
                on: {
                  updateValue: function (value) {
                    return _vm.setContractorInfo({
                      id: contractor.id,
                      key: "userAccount",
                      val: value,
                    })
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("td", [
            _c(
              "div",
              { staticClass: "name-input" },
              _vm._l(_vm.getFullnameSorts, function (fullnameObj) {
                return _c("input", {
                  key: fullnameObj.key,
                  class: [
                    "name-input__part",
                    !contractor.validation[fullnameObj.value] &&
                      "error-highlight",
                  ],
                  domProps: { value: contractor[fullnameObj.value] },
                  on: {
                    input: function (e) {
                      return _vm.setContractorInfo({
                        id: contractor.id,
                        key: fullnameObj.value,
                        val: e.target.value,
                      })
                    },
                  },
                })
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c(
            "td",
            [
              _c("HKLSelect", {
                class: [
                  "contractor-type__select",
                  !contractor.validation.contractorType && "error-highlight",
                ],
                attrs: {
                  value: contractor.contractorType || undefined,
                  options: _vm.contractorTypeHklOptions,
                  showSearch: true,
                  dropdownMatchSelectWidth: false,
                  title: contractor.contractorType,
                  placeholder: "",
                },
                on: {
                  change: function (val) {
                    return _vm.setContractorInfo({
                      id: contractor.id,
                      key: "contractorType",
                      val: val,
                    })
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "td",
            [
              _c("HKLSelect", {
                directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                class: [
                  "company-input",
                  !contractor.validation.companyName && "error-highlight",
                ],
                attrs: {
                  value: contractor.companyName || undefined,
                  options: _vm.companyHklOptions,
                  showSearch: true,
                  dropdownMatchSelectWidth: false,
                  singleTaggableInput: true,
                  title: contractor.companyName,
                  placeholder: "",
                },
                on: {
                  search: function (val) {
                    return _vm.onCompanySearch(val)
                  },
                  input: function (val) {
                    return _vm.onCompanyInput(val, contractor.id)
                  },
                  change: function (val) {
                    return _vm.onCompanyChange(val, contractor.id)
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("td", [
            _c("input", {
              class: [
                "office-tel-input",
                !contractor.validation.officeTel && "error-highlight",
              ],
              domProps: { value: contractor.officeTel },
              on: {
                input: function (e) {
                  return _vm.setContractorInfo({
                    id: contractor.id,
                    key: "officeTel",
                    val: e.target.value,
                  })
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("td", [
            _c("input", {
              class: [
                "mobile-input",
                !contractor.validation.mobile && "error-highlight",
              ],
              domProps: { value: contractor.mobile },
              on: {
                input: function (e) {
                  return _vm.setContractorInfo({
                    id: contractor.id,
                    key: "mobile",
                    val: e.target.value,
                  })
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("td", { staticClass: "last-login" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.formatDate(contractor.user.lastLoginAt)) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c("td", { staticClass: "last-invite" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.formatDate(contractor.lastInviteDateTime)) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c("td", [
            _c("i", {
              staticClass: "fa fa-times fa-lg delete-icon",
              on: {
                click: function ($event) {
                  return _vm.toggleDeleteModal({ id: contractor.id })
                },
              },
            }),
          ]),
        ])
      }),
      _vm._v(" "),
      _c("Modal", { ref: "deleteModal" }, [
        _c("div", { attrs: { slot: "content" }, slot: "content" }, [
          _c("p", { staticClass: "modal-pure-text" }, [
            _vm._v("\n        " + _vm._s(_vm.deleteModalContent) + "\n      "),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
          _c(
            "button",
            {
              staticClass: "cancel btn btn--darkblue",
              on: { click: _vm.cancelDelete },
            },
            [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("action.cancel")) + "\n      "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "comfirm btn btn--orange",
              on: { click: _vm.confirmDelete },
            },
            [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("action.delete")) + "\n      "
              ),
            ]
          ),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }